export default __webpack_public_path__ + "static/media/ranking.cc1aa831.svg";